import angular from "angular";
import DocumentSigningView from "../../../common/directives/document-signing-view/document-signing-view.module";
import PDFViewerDirective from "../../../common/directives/pdf-viewer/pdf-viewer.module";
import controller from "./student-sign-document.controller";
import template from "./student-sign-document.html";

function config($stateProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.student.documents.sign", {
    url: "/sign/:documentId",
    template: template,
    controller: controller,
    controllerAs: "vm",
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.parent,
        USER_ROLES.owner,
        USER_ROLES.student,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "USER_ROLES"];

export default angular
  .module("student.documents.sign", [
    DocumentSigningView.name,
    PDFViewerDirective.name,
  ])
  .config(config)
  .controller("StudentSignDocumentController", controller);
